﻿import { Confirm } from './confirm';
Confirm.Initialize();

import { VideoUtils } from './video-utils';

import { VDXCall } from './vdx-call';
import { WaitingList } from './waiting-list';
import { ShareLink } from './share-link';
import { CreateMeeting } from './create-meeting';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
(window as any).Vk = {
    VDXCall,
    WaitingList: WaitingList,
    ShareLink: ShareLink,
    CreateMeeting: CreateMeeting,
    VideoUtils: VideoUtils,
};
